import EquipmentField from './EquipmentField'

export default EquipmentField
